import { render, staticRenderFns } from "./MassiveImportCollaboratorProjectDetailModal.vue?vue&type=template&id=63efeeb2&scoped=true&"
import script from "./MassiveImportCollaboratorProjectDetailModal.vue?vue&type=script&lang=js&"
export * from "./MassiveImportCollaboratorProjectDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./MassiveImportCollaboratorProjectDetailModal.vue?vue&type=style&index=0&id=63efeeb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63efeeb2",
  null
  
)

export default component.exports